import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "ActNavigation" }
const _hoisted_2 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isPreviousStepPossible)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "NavigationBackButton",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleBackClick && _ctx.handleBackClick(...args)))
        }, " Back "))
      : _createCommentVNode("v-if", true),
    _createElementVNode("button", {
      ref: "confirmButton",
      class: "DriverButton",
      "data-style": "zoom-in",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleNextClick && _ctx.handleNextClick(...args))),
      disabled: !_ctx.isNextStepPossible
    }, _toDisplayString(_ctx.isLastStepReached ? 'Confirm' : 'Next'), 9 /* TEXT, PROPS */, _hoisted_2)
  ]))
}